import { render, staticRenderFns } from "./DiscograficasRock.vue?vue&type=template&id=69e17bcd&"
import script from "./DiscograficasRock.vue?vue&type=script&lang=js&"
export * from "./DiscograficasRock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports